import { render, staticRenderFns } from "./SharingFacebookMetadata.vue?vue&type=template&id=b68128f6&"
import script from "./SharingFacebookMetadata.vue?vue&type=script&lang=js&"
export * from "./SharingFacebookMetadata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports